import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, CircleMarker, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Gift, MapPin, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function MapView() {
  const navigate = useNavigate();
  const [cities, setCities] = useState([]);

  useEffect(() => { api.get("/public/map-stats").then(({ data }) => setCities(data)).catch(() => {}); }, []);

  const withCoords = cities.filter((c) => c.lat && c.lng);
  const maxCount = Math.max(1, ...cities.map((c) => c.count));

  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-[1000] glass border-b border-border/60">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <button onClick={() => navigate(-1)} className="flex items-center gap-2 font-semibold" data-testid="map-back"><ArrowLeft className="h-4 w-4" /> Indietro</button>
          <div className="flex items-center gap-2"><div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center"><Gift className="h-4 w-4 text-primary-foreground" /></div><span className="font-head font-extrabold text-primary">Ti Regalo</span></div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <h1 className="font-head font-extrabold text-3xl sm:text-4xl tracking-tight">Mappa dei regali</h1>
        <p className="text-muted-foreground mt-2">Scopri quanti oggetti gratis ci sono in ogni città. Clicca una città per vedere gli annunci.</p>

        <div className="grid lg:grid-cols-3 gap-6 mt-8">
          <div className="lg:col-span-2 rounded-2xl overflow-hidden border border-border/60 tactile-shadow" style={{ height: "520px" }} data-testid="map-container">
            <MapContainer center={[42.5, 12.5]} zoom={5} style={{ height: "100%", width: "100%" }} scrollWheelZoom={true}>
              <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {withCoords.map((c) => (
                <CircleMarker key={c.city} center={[c.lat, c.lng]} radius={8 + (c.count / maxCount) * 22}
                  pathOptions={{ color: "#4b6b3f", fillColor: "#c8622f", fillOpacity: 0.75, weight: 2 }}
                  eventHandlers={{ click: () => navigate(`/esplora?city=${encodeURIComponent(c.city)}`) }}>
                  <Tooltip><b>{c.city}</b>: {c.count} regali</Tooltip>
                </CircleMarker>
              ))}
            </MapContainer>
          </div>

          <div className="rounded-2xl border border-border/60 bg-card p-4 tactile-shadow">
            <h2 className="font-head font-bold text-lg mb-3">Regali per città</h2>
            <div className="space-y-1 max-h-[460px] overflow-auto">
              {cities.length === 0 && <p className="text-sm text-muted-foreground">Nessun dato disponibile.</p>}
              {cities.map((c) => (
                <button key={c.city} onClick={() => navigate(`/esplora?city=${encodeURIComponent(c.city)}`)} data-testid={`map-city-${c.city}`}
                  className="w-full flex items-center justify-between px-3 py-2 rounded-xl hover:bg-secondary transition-colors text-left">
                  <span className="flex items-center gap-2 text-sm font-medium"><MapPin className="h-4 w-4 text-primary" /> {c.city}</span>
                  <span className="text-sm font-bold text-accent">{c.count}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
